import { render } from "./DashboardContainerNavbar.vue?vue&type=template&id=1d2b4557&scoped=true&ts=true"
import script from "./DashboardContainerNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardContainerNavbar.vue?vue&type=script&lang=ts"

import "./DashboardContainerNavbar.vue?vue&type=style&index=0&id=1d2b4557&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2b4557"]])

export default __exports__